const Linkedin = () => (
  <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.31878 2.8227C6.28347 1.2204 5.13767 0 3.27704 0C1.41642 0 0.200012 1.2204 0.200012 2.8227C0.200012 4.3918 1.38047 5.64735 3.20644 5.64735H3.2412C5.13767 5.64735 6.31878 4.3918 6.31878 2.8227ZM5.96053 7.87787H0.521606V24.2196H5.96053V7.87787ZM19.3131 7.49414C22.8922 7.49414 25.5754 9.83028 25.5754 14.8497L25.5751 24.2196H20.1364V15.4768C20.1364 13.2808 19.3494 11.7823 17.3805 11.7823C15.8779 11.7823 14.9828 12.7925 14.5898 13.7682C14.4459 14.1179 14.4106 14.6051 14.4106 15.0935V24.22H8.97107C8.97107 24.22 9.04276 9.41173 8.97107 7.87831H14.4106V10.193C15.1325 9.08027 16.4254 7.49414 19.3131 7.49414Z"
      fill="#ffffff"
    />
  </svg>
)

export default Linkedin
